/* Jam records per song in progress.records["jam.<id>"]: new keys next to the song's own "song.<id>"
   transcription state, so nothing saved before Jam existed changes. */
import type { JamResult } from '../../core/jam';
import { getRecord, setRecord } from '../../core/store';

export interface JamRecord {
  /** best score */
  best: number;
  /** best accuracy, 0..1 */
  acc: number;
  /** longest streak */
  streak: number;
  stars: number;
  plays: number;
  /** time of the last saved game */
  last: number;
}

export const jamKey = (id: string): string => `jam.${id}`;

export function loadJamRecord(id: string): JamRecord | null {
  const raw = getRecord<Partial<JamRecord>>(jamKey(id));
  if (!raw) return null;
  return {
    best: raw.best || 0,
    acc: raw.acc || 0,
    streak: raw.streak || 0,
    stars: raw.stars || 0,
    plays: raw.plays || 0,
    last: raw.last || 0,
  };
}

/** Saves a finished game played on the guitar; returns the previous record and whether the score beat it. */
export function saveJamRecord(id: string, r: JamResult): { prev: JamRecord | null; next: JamRecord; newBest: boolean } {
  const prev = loadJamRecord(id);
  const next: JamRecord = {
    best: Math.max(prev?.best ?? 0, r.score),
    acc: Math.max(prev?.acc ?? 0, r.acc),
    streak: Math.max(prev?.streak ?? 0, r.bestStreak),
    stars: Math.max(prev?.stars ?? 0, r.stars),
    plays: (prev?.plays ?? 0) + 1,
    last: Date.now(),
  };
  setRecord(jamKey(id), next);
  return { prev, next, newBest: r.score > (prev?.best ?? 0) };
}
